import { SET_ACTIVE_NAV, PURGE_NAV } from "../constants/actions.type";
import {
  GET_LIST_NAV,
  SET_LIST_NAV,
  FETCH_LIST_NAV,
  SET_PRIVILEGE,
  PURGE_LIST_NAV,
  UPDATE_ACTIVE_NAV,
  SET_NAV_LOADING
} from "../constants/mutations.type";
import LocalStorageService from "@/common/LocalStorageService";
import RoleService from "@/services/resources/role.service";
import { defaultMenu, HEADER } from "@/router/_nav.js";
import Helper from "@/common/helper";

const states = {
  nav: [],
  loading: false,
  privilege: null
};

const getters = {
  navList(state) {
    return state.nav;
  },
  navLoading(state) {
    return state.loading;
  },
  privilege(state) {
    return Helper.findRoute(state.nav, state.privilege);
  },
  isFullAccess(state) {
    const privilege = Helper.findRoute(state.nav, state.privilege);
    return privilege && privilege.description == "Full Access";
  }
  // isFullAccess() {
  //   return true;
  // }
};

const actions = {
  [SET_ACTIVE_NAV]({ state, commit }, params) {
    function fetchNavFromRoleService(commit) {
      commit(SET_NAV_LOADING, true);
      RoleService.getPrivileges()
        .then(({ data }) => {
          const listRoute = generateListRoute(data.result.userRoles);
          commit(FETCH_LIST_NAV, listRoute);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => commit(SET_NAV_LOADING, false));
    }

    function generateListRoute(userRoles) {
      let listRoute = [...defaultMenu];
      let starts = {
        [HEADER.BERANDA]: 1,
        [HEADER.MIDDLE]: 1,
        [HEADER.NMC]: 1,
        [HEADER.UFI]: 1,
        [HEADER.CMS]: 1,
        [HEADER.SETUP]: 1,
        [HEADER.SETTING]: 1,
        [HEADER.OTHER]: 1
      };

      userRoles.forEach(role => {
        listRoute = mergeRolePermissions(listRoute, role.permission, starts);
      });

      listRoute = filterNavHeaders(listRoute, starts);

      return listRoute;
    }

    function mergeRolePermissions(listRoute, permissions, starts) {
      permissions.forEach(permission => {
        const found = listRoute.find(
          item => item.menu_name === permission.menu_name
        );
        if (found) {
          mergeChildren(found, permission);
        } else if (!permission.header) {
          insertPermission(listRoute, permission, starts);
        }
      });
      return listRoute;
    }

    function mergeChildren(found, permission) {
      found.description = permission.description;
      found.children = mergeChildPermissions(
        found.children || [],
        permission.children || []
      );
    }

    function mergeChildPermissions(existingChildren, newChildren) {
      newChildren.forEach(child => {
        const existingChild = existingChildren.find(
          c => c.submenu_name === child.submenu_name
        );
        if (existingChild) {
          existingChild.description = child.description;
        } else {
          existingChildren.push(child);
        }
      });
      return existingChildren;
    }

    function insertPermission(listRoute, permission, starts) {
      permission.active = false;
      const header = permission.category || HEADER.OTHER;
      const headerIndex = listRoute.findIndex(item => item.header === header);
      const start = starts[header]++;
      listRoute.splice(headerIndex + start, 0, permission);
    }

    function filterNavHeaders(listRoute, starts) {
      return listRoute.filter(item => {
        if (item.header) {
          return starts[item.header] > 1;
        }
        return true;
      });
    }

    commit(GET_LIST_NAV);
    if (state.nav && state.nav.length > 0) {
      commit(UPDATE_ACTIVE_NAV, {
        items: state.nav,
        currentRoute: params.currentRoute
      });
    } else {
      fetchNavFromRoleService(commit);
    }
  },
  [PURGE_NAV]({ commit }) {
    commit(PURGE_LIST_NAV);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [GET_LIST_NAV](state) {
    var listMenu = LocalStorageService.getMenu();
    if (listMenu) {
      state.nav = JSON.parse(listMenu);
    } else {
      state.nav = [];
    }
  },
  [SET_LIST_NAV](state, data) {
    state.nav = data;
  },
  [FETCH_LIST_NAV](state, data) {
    state.nav = data;
    LocalStorageService.saveMenu(JSON.stringify(data));
  },
  [SET_PRIVILEGE](state, data) {
    state.privilege = data;
  },
  [SET_NAV_LOADING](state, data) {
    state.loading = data;
  },
  [PURGE_LIST_NAV](state) {
    state.nav = [];
  },
  [UPDATE_ACTIVE_NAV](state, data) {
    let items = data.items;
    let currentRoute = data.currentRoute;
    items.forEach(function iter(a) {
      a.active = false;
      if (a.name == currentRoute) {
        a.active = true;
      } else {
        if (Array.isArray(a.children)) {
          var routeFound = Helper.findRoute(a.children, currentRoute);
          if (routeFound) {
            a.active = true;
          }
          a.children.forEach(iter);
        }
      }
      return a;
    });
    state.nav = items;
  }
};

export default {
  state: states,
  getters,
  actions,
  mutations
};
